export const headerFileTable = [
  {
    headerStyles: 'w-[7%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[7%] py-5 break-all pl-4 align-top',
    name: 'File Id',
    label: 'fileId',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: true,
  },
  {
    headerStyles: 'w-[27%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[27%] py-5 break-all pl-4 align-top',
    name: 'File Name',
    label: 'fileName',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[10%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[10%] py-5 break-all pl-4 align-top',
    name: 'Row',
    label: 'totalRow',
    isFilter: true,
    isFilterDate: true,
    isOneLineRes: true,
  },
  {
    headerStyles: 'w-[11%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[11%] py-5 break-all pl-4 align-top',
    name: 'Success',
    label: 'totalSuccess',
    isFilter: true,
    isFilterDate: true,
    isOneLineRes: true,
  },
  {
    headerStyles: 'w-[10%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[10%] py-5 break-all pl-4 align-top',
    name: 'Failure',
    label: 'totalFailure',
    isFilter: true,
    isFilterDate: true,
    isOneLineRes: true,
  },
  {
    headerStyles: 'w-[15%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[15%] py-5 break-all pl-4 align-top',
    name: 'Status',
    label: 'fileStatus',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[15%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[15%] py-5 break-all pl-4 align-top',
    name: 'Upload At',
    label: 'uploadAt',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  {
    headerStyles: 'w-[5%] font-semibold py-5 pr-4 ',
    rowWid: 'w-[5%] py-5 pr-4 align-top text-center',
    name: 'Action',
    label: 'uploadAt',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
]
